import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  fa500px,
  faAccessibleIcon,
  faAccusoft,
  faAcquisitionsIncorporated,
  faAdn,
  faAdversal,
  faAffiliatetheme,
  faAirbnb,
  faAlgolia,
  faAlipay,
  faAmazon,
  faAmazonPay,
  faAmilia,
  faAndroid,
  faAngellist,
  faAngrycreative,
  faAngular,
  faAppStore,
  faAppStoreIos,
  faApper,
  faApple,
  faApplePay,
  faArtstation,
  faAsymmetrik,
  faAtlassian,
  faAudible,
  faAutoprefixer,
  faAvianex,
  faAviato,
  faAws,
  faBandcamp,
  faBattleNet,
  faBehance,
  faBehanceSquare,
  faBimobject,
  faBitbucket,
  faBitcoin,
  faBity,
  faBlackTie,
  faBlackberry,
  faBlogger,
  faBloggerB,
  faBluetooth,
  faBluetoothB,
  faBootstrap,
  faBtc,
  faBuffer,
  faBuromobelexperte,
  faBuyNLarge,
  faBuysellads,
  faCanadianMapleLeaf,
  faCcAmazonPay,
  faCcAmex,
  faCcApplePay,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faCcMastercard,
  faCcPaypal,
  faCcStripe,
  faCcVisa,
  faCentercode,
  faCentos,
  faChrome,
  faChromecast,
  faCloudflare,
  faCloudscale,
  faCloudsmith,
  faCloudversify,
  faCodepen,
  faCodiepie,
  faConfluence,
  faConnectdevelop,
  faContao,
  faCottonBureau,
  faCpanel,
  faCreativeCommons,
  faCreativeCommonsBy,
  faCreativeCommonsNc,
  faCreativeCommonsNcEu,
  faCreativeCommonsNcJp,
  faCreativeCommonsNd,
  faCreativeCommonsPd,
  faCreativeCommonsPdAlt,
  faCreativeCommonsRemix,
  faCreativeCommonsSa,
  faCreativeCommonsSampling,
  faCreativeCommonsSamplingPlus,
  faCreativeCommonsShare,
  faCreativeCommonsZero,
  faCriticalRole,
  faCss3,
  faCss3Alt,
  faCuttlefish,
  faDAndD,
  faDAndDBeyond,
  faDailymotion,
  faDashcube,
  faDeezer,
  faDelicious,
  faDeploydog,
  faDeskpro,
  faDev,
  faDeviantart,
  faDhl,
  faDiaspora,
  faDigg,
  faDigitalOcean,
  faDiscord,
  faDiscourse,
  faDochub,
  faDocker,
  faDraft2digital,
  faDribbble,
  faDribbbleSquare,
  faDropbox,
  faDrupal,
  faDyalog,
  faEarlybirds,
  faEbay,
  faEdge,
  faEdgeLegacy,
  faElementor,
  faEllo,
  faEmber,
  faEmpire,
  faEnvira,
  faErlang,
  faEthereum,
  faEtsy,
  faEvernote,
  faExpeditedssl,
  faFacebook,
  faFacebookF,
  faFacebookMessenger,
  faFacebookSquare,
  faFantasyFlightGames,
  faFedex,
  faFedora,
  faFigma,
  faFirefox,
  faFirefoxBrowser,
  faFirstOrder,
  faFirstOrderAlt,
  faFirstdraft,
  faFlickr,
  faFlipboard,
  faFly,
  faFontAwesome,
  faFontAwesomeAlt,
  faFontAwesomeFlag,
  faFontAwesomeLogoFull,
  faFonticons,
  faFonticonsFi,
  faFortAwesome,
  faFortAwesomeAlt,
  faForumbee,
  faFoursquare,
  faFreeCodeCamp,
  faFreebsd,
  faFulcrum,
  faGalacticRepublic,
  faGalacticSenate,
  faGetPocket,
  faGg,
  faGgCircle,
  faGit,
  faGitAlt,
  faGitSquare,
  faGithub,
  faGithubAlt,
  faGithubSquare,
  faGitkraken,
  faGitlab,
  faGitter,
  faGlide,
  faGlideG,
  faGofore,
  faGoodreads,
  faGoodreadsG,
  faGoogle,
  faGoogleDrive,
  faGooglePay,
  faGooglePlay,
  faGooglePlus,
  faGooglePlusG,
  faGooglePlusSquare,
  faGoogleWallet,
  faGratipay,
  faGrav,
  faGripfire,
  faGrunt,
  faGuilded,
  faGulp,
  faHackerNews,
  faHackerNewsSquare,
  faHackerrank,
  faHips,
  faHireAHelper,
  faHive,
  faHooli,
  faHornbill,
  faHotjar,
  faHouzz,
  faHtml5,
  faHubspot,
  faIdeal,
  faImdb,
  faInnosoft,
  faInstagram,
  faInstagramSquare,
  faInstalod,
  faIntercom,
  faInternetExplorer,
  faInvision,
  faIoxhost,
  faItchIo,
  faItunes,
  faItunesNote,
  faJava,
  faJediOrder,
  faJenkins,
  faJira,
  faJoget,
  faJoomla,
  faJs,
  faJsSquare,
  faJsfiddle,
  faKaggle,
  faKeybase,
  faKeycdn,
  faKickstarter,
  faKickstarterK,
  faKorvue,
  faLaravel,
  faLastfm,
  faLastfmSquare,
  faLeanpub,
  faLess,
  faLine,
  faLinkedin,
  faLinkedinIn,
  faLinode,
  faLinux,
  faLyft,
  faMagento,
  faMailchimp,
  faMandalorian,
  faMarkdown,
  faMastodon,
  faMaxcdn,
  faMdb,
  faMedapps,
  faMedium,
  faMediumM,
  faMedrt,
  faMeetup,
  faMegaport,
  faMendeley,
  faMicroblog,
  faMicrosoft,
  faMix,
  faMixcloud,
  faMixer,
  faMizuni,
  faModx,
  faMonero,
  faNapster,
  faNeos,
  faNimblr,
  faNode,
  faNodeJs,
  faNpm,
  faNs8,
  faNutritionix,
  faOctopusDeploy,
  faOdnoklassniki,
  faOdnoklassnikiSquare,
  faOldRepublic,
  faOpencart,
  faOpenid,
  faOpera,
  faOptinMonster,
  faOrcid,
  faOsi,
  faPage4,
  faPagelines,
  faPalfed,
  faPatreon,
  faPaypal,
  faPennyArcade,
  faPerbyte,
  faPeriscope,
  faPhabricator,
  faPhoenixFramework,
  faPhoenixSquadron,
  faPhp,
  faPiedPiper,
  faPiedPiperAlt,
  faPiedPiperHat,
  faPiedPiperPp,
  faPiedPiperSquare,
  faPinterest,
  faPinterestP,
  faPinterestSquare,
  faPlaystation,
  faProductHunt,
  faPushed,
  faPython,
  faQq,
  faQuinscape,
  faQuora,
  faRProject,
  faRaspberryPi,
  faRavelry,
  faReact,
  faReacteurope,
  faReadme,
  faRebel,
  faRedRiver,
  faReddit,
  faRedditAlien,
  faRedditSquare,
  faRedhat,
  faRenren,
  faReplyd,
  faResearchgate,
  faResolving,
  faRev,
  faRocketchat,
  faRockrms,
  faRust,
  faSafari,
  faSalesforce,
  faSass,
  faSchlix,
  faScribd,
  faSearchengin,
  faSellcast,
  faSellsy,
  faServicestack,
  faShirtsinbulk,
  faShopify,
  faShopware,
  faSimplybuilt,
  faSistrix,
  faSith,
  faSketch,
  faSkyatlas,
  faSkype,
  faSlack,
  faSlackHash,
  faSlideshare,
  faSnapchat,
  faSnapchatGhost,
  faSnapchatSquare,
  faSoundcloud,
  faSourcetree,
  faSpeakap,
  faSpeakerDeck,
  faSpotify,
  faSquarespace,
  faStackExchange,
  faStackOverflow,
  faStackpath,
  faStaylinked,
  faSteam,
  faSteamSquare,
  faSteamSymbol,
  faStickerMule,
  faStrava,
  faStripe,
  faStripeS,
  faStudiovinari,
  faStumbleupon,
  faStumbleuponCircle,
  faSuperpowers,
  faSupple,
  faSuse,
  faSwift,
  faSymfony,
  faTeamspeak,
  faTelegram,
  faTelegramPlane,
  faTencentWeibo,
  faTheRedYeti,
  faThemeco,
  faThemeisle,
  faThinkPeaks,
  faTiktok,
  faTradeFederation,
  faTrello,
  faTumblr,
  faTumblrSquare,
  faTwitch,
  faTwitter,
  faTwitterSquare,
  faTypo3,
  faUber,
  faUbuntu,
  faUikit,
  faUmbraco,
  faUncharted,
  faUniregistry,
  faUnity,
  faUnsplash,
  faUntappd,
  faUps,
  faUsb,
  faUsps,
  faUssunnah,
  faVaadin,
  faViacoin,
  faViadeo,
  faViadeoSquare,
  faViber,
  faVimeo,
  faVimeoSquare,
  faVimeoV,
  faVine,
  faVk,
  faVnv,
  faVuejs,
  faWatchmanMonitoring,
  faWaze,
  faWeebly,
  faWeibo,
  faWeixin,
  faWhatsapp,
  faWhatsappSquare,
  faWhmcs,
  faWikipediaW,
  faWindows,
  faWix,
  faWizardsOfTheCoast,
  faWodu,
  faWolfPackBattalion,
  faWordpress,
  faWordpressSimple,
  faWpbeginner,
  faWpexplorer,
  faWpforms,
  faWpressr,
  faXbox,
  faXing,
  faXingSquare,
  faYCombinator,
  faYahoo,
  faYammer,
  faYandex,
  faYandexInternational,
  faYarn,
  faYelp,
  faYoast,
  faYoutube,
  faYoutubeSquare,
  faZhihu
} from '@fortawesome/free-brands-svg-icons';
import {
  faAd,
  faAddressBook,
  faAddressCard,
  faAdjust,
  faAirFreshener,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAllergies,
  faAmbulance,
  faAmericanSignLanguageInterpreting,
  faAnchor,
  faAngleDoubleDown,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDoubleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faAngry,
  faAnkh,
  faAppleAlt,
  faArchive,
  faArchway,
  faArrowAltCircleDown,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faArrowAltCircleUp,
  faArrowCircleDown,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowCircleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowsAlt,
  faArrowsAltH,
  faArrowsAltV,
  faAssistiveListeningSystems,
  faAsterisk,
  faAt,
  faAtlas,
  faAtom,
  faAudioDescription,
  faAward,
  faBaby,
  faBabyCarriage,
  faBackspace,
  faBackward,
  faBacon,
  faBacteria,
  faBacterium,
  faBahai,
  faBalanceScale,
  faBalanceScaleLeft,
  faBalanceScaleRight,
  faBan,
  faBandAid,
  faBarcode,
  faBars,
  faBaseballBall,
  faBasketballBall,
  faBath,
  faBatteryEmpty,
  faBatteryFull,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryThreeQuarters,
  faBed,
  faBeer,
  faBell,
  faBellSlash,
  faBezierCurve,
  faBible,
  faBicycle,
  faBiking,
  faBinoculars,
  faBiohazard,
  faBirthdayCake,
  faBlender,
  faBlenderPhone,
  faBlind,
  faBlog,
  faBold,
  faBolt,
  faBomb,
  faBone,
  faBong,
  faBook,
  faBookDead,
  faBookMedical,
  faBookOpen,
  faBookReader,
  faBookmark,
  faBorderAll,
  faBorderNone,
  faBorderStyle,
  faBowlingBall,
  faBox,
  faBoxOpen,
  faBoxTissue,
  faBoxes,
  faBraille,
  faBrain,
  faBreadSlice,
  faBriefcase,
  faBriefcaseMedical,
  faBroadcastTower,
  faBroom,
  faBrush,
  faBug,
  faBuilding,
  faBullhorn,
  faBullseye,
  faBurn,
  faBus,
  faBusAlt,
  faBusinessTime,
  faCalculator,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDay,
  faCalendarMinus,
  faCalendarPlus,
  faCalendarTimes,
  faCalendarWeek,
  faCamera,
  faCameraRetro,
  faCampground,
  faCandyCane,
  faCannabis,
  faCapsules,
  faCar,
  faCarAlt,
  faCarBattery,
  faCarCrash,
  faCarSide,
  faCaravan,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretSquareDown,
  faCaretSquareLeft,
  faCaretSquareRight,
  faCaretSquareUp,
  faCaretUp,
  faCarrot,
  faCartArrowDown,
  faCartPlus,
  faCashRegister,
  faCat,
  faCertificate,
  faChair,
  faChalkboard,
  faChalkboardTeacher,
  faChargingStation,
  faChartArea,
  faChartBar,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faCheese,
  faChess,
  faChessBishop,
  faChessBoard,
  faChessKing,
  faChessKnight,
  faChessPawn,
  faChessQueen,
  faChessRook,
  faChevronCircleDown,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronCircleUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChild,
  faChurch,
  faCircle,
  faCircleNotch,
  faCity,
  faClinicMedical,
  faClipboard,
  faClipboardCheck,
  faClipboardList,
  faClock,
  faClone,
  faClosedCaptioning,
  faCloud,
  faCloudDownloadAlt,
  faCloudMeatball,
  faCloudMoon,
  faCloudMoonRain,
  faCloudRain,
  faCloudShowersHeavy,
  faCloudSun,
  faCloudSunRain,
  faCloudUploadAlt,
  faCocktail,
  faCode,
  faCodeBranch,
  faCoffee,
  faCog,
  faCogs,
  faCoins,
  faColumns,
  faComment,
  faCommentAlt,
  faCommentDollar,
  faCommentDots,
  faCommentMedical,
  faCommentSlash,
  faComments,
  faCommentsDollar,
  faCompactDisc,
  faCompass,
  faCompress,
  faCompressAlt,
  faCompressArrowsAlt,
  faConciergeBell,
  faCookie,
  faCookieBite,
  faCopy,
  faCopyright,
  faCouch,
  faCreditCard,
  faCrop,
  faCropAlt,
  faCross,
  faCrosshairs,
  faCrow,
  faCrown,
  faCrutch,
  faCube,
  faCubes,
  faCut,
  faDatabase,
  faDeaf,
  faDemocrat,
  faDesktop,
  faDharmachakra,
  faDiagnoses,
  faDice,
  faDiceD20,
  faDiceD6,
  faDiceFive,
  faDiceFour,
  faDiceOne,
  faDiceSix,
  faDiceThree,
  faDiceTwo,
  faDigitalTachograph,
  faDirections,
  faDisease,
  faDivide,
  faDizzy,
  faDna,
  faDog,
  faDollarSign,
  faDolly,
  faDollyFlatbed,
  faDonate,
  faDoorClosed,
  faDoorOpen,
  faDotCircle,
  faDove,
  faDownload,
  faDraftingCompass,
  faDragon,
  faDrawPolygon,
  faDrum,
  faDrumSteelpan,
  faDrumstickBite,
  faDumbbell,
  faDumpster,
  faDumpsterFire,
  faDungeon,
  faEdit,
  faEgg,
  faEject,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faEnvelopeSquare,
  faEquals,
  faEraser,
  faEthernet,
  faEuroSign,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExpandAlt,
  faExpandArrowsAlt,
  faExternalLinkAlt,
  faExternalLinkSquareAlt,
  faEye,
  faEyeDropper,
  faEyeSlash,
  faFan,
  faFastBackward,
  faFastForward,
  faFaucet,
  faFax,
  faFeather,
  faFeatherAlt,
  faFemale,
  faFighterJet,
  faFile,
  faFileAlt,
  faFileArchive,
  faFileAudio,
  faFileCode,
  faFileContract,
  faFileCsv,
  faFileDownload,
  faFileExcel,
  faFileExport,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFileMedicalAlt,
  faFilePdf,
  faFilePowerpoint,
  faFilePrescription,
  faFileSignature,
  faFileUpload,
  faFileVideo,
  faFileWord,
  faFill,
  faFillDrip,
  faFilm,
  faFilter,
  faFingerprint,
  faFire,
  faFireAlt,
  faFireExtinguisher,
  faFirstAid,
  faFish,
  faFistRaised,
  faFlag,
  faFlagCheckered,
  faFlagUsa,
  faFlask,
  faFlushed,
  faFolder,
  faFolderMinus,
  faFolderOpen,
  faFolderPlus,
  faFont,
  faFontAwesomeLogoFull as zmfaFontAwesomeLogoFull,
  faFootballBall,
  faForward,
  faFrog,
  faFrown,
  faFrownOpen,
  faFunnelDollar,
  faFutbol,
  faGamepad,
  faGasPump,
  faGavel,
  faGem,
  faGenderless,
  faGhost,
  faGift,
  faGifts,
  faGlassCheers,
  faGlassMartini,
  faGlassMartiniAlt,
  faGlassWhiskey,
  faGlasses,
  faGlobe,
  faGlobeAfrica,
  faGlobeAmericas,
  faGlobeAsia,
  faGlobeEurope,
  faGolfBall,
  faGopuram,
  faGraduationCap,
  faGreaterThan,
  faGreaterThanEqual,
  faGrimace,
  faGrin,
  faGrinAlt,
  faGrinBeam,
  faGrinBeamSweat,
  faGrinHearts,
  faGrinSquint,
  faGrinSquintTears,
  faGrinStars,
  faGrinTears,
  faGrinTongue,
  faGrinTongueSquint,
  faGrinTongueWink,
  faGrinWink,
  faGripHorizontal,
  faGripLines,
  faGripLinesVertical,
  faGripVertical,
  faGuitar,
  faHSquare,
  faHamburger,
  faHammer,
  faHamsa,
  faHandHolding,
  faHandHoldingHeart,
  faHandHoldingMedical,
  faHandHoldingUsd,
  faHandHoldingWater,
  faHandLizard,
  faHandMiddleFinger,
  faHandPaper,
  faHandPeace,
  faHandPointDown,
  faHandPointLeft,
  faHandPointRight,
  faHandPointUp,
  faHandPointer,
  faHandRock,
  faHandScissors,
  faHandSparkles,
  faHandSpock,
  faHands,
  faHandsHelping,
  faHandsWash,
  faHandshake,
  faHandshakeAltSlash,
  faHandshakeSlash,
  faHanukiah,
  faHardHat,
  faHashtag,
  faHatCowboy,
  faHatCowboySide,
  faHatWizard,
  faHdd,
  faHeadSideCough,
  faHeadSideCoughSlash,
  faHeadSideMask,
  faHeadSideVirus,
  faHeading,
  faHeadphones,
  faHeadphonesAlt,
  faHeadset,
  faHeart,
  faHeartBroken,
  faHeartbeat,
  faHelicopter,
  faHighlighter,
  faHiking,
  faHippo,
  faHistory,
  faHockeyPuck,
  faHollyBerry,
  faHome,
  faHorse,
  faHorseHead,
  faHospital,
  faHospitalAlt,
  faHospitalSymbol,
  faHospitalUser,
  faHotTub,
  faHotdog,
  faHotel,
  faHourglass,
  faHourglassEnd,
  faHourglassHalf,
  faHourglassStart,
  faHouseDamage,
  faHouseUser,
  faHryvnia,
  faICursor,
  faIceCream,
  faIcicles,
  faIcons,
  faIdBadge,
  faIdCard,
  faIdCardAlt,
  faIgloo,
  faImage,
  faImages,
  faInbox,
  faIndent,
  faIndustry,
  faInfinity,
  faInfo,
  faInfoCircle,
  faItalic,
  faJedi,
  faJoint,
  faJournalWhills,
  faKaaba,
  faKey,
  faKeyboard,
  faKhanda,
  faKiss,
  faKissBeam,
  faKissWinkHeart,
  faKiwiBird,
  faLandmark,
  faLanguage,
  faLaptop,
  faLaptopCode,
  faLaptopHouse,
  faLaptopMedical,
  faLaugh,
  faLaughBeam,
  faLaughSquint,
  faLaughWink,
  faLayerGroup,
  faLeaf,
  faLemon,
  faLessThan,
  faLessThanEqual,
  faLevelDownAlt,
  faLevelUpAlt,
  faLifeRing,
  faLightbulb,
  faLink,
  faLiraSign,
  faList,
  faListAlt,
  faListOl,
  faListUl,
  faLocationArrow,
  faLock,
  faLockOpen,
  faLongArrowAltDown,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faLongArrowAltUp,
  faLowVision,
  faLuggageCart,
  faLungs,
  faLungsVirus,
  faMagic,
  faMagnet,
  faMailBulk,
  faMale,
  faMap,
  faMapMarked,
  faMapMarkedAlt,
  faMapMarker,
  faMapMarkerAlt,
  faMapPin,
  faMapSigns,
  faMarker,
  faMars,
  faMarsDouble,
  faMarsStroke,
  faMarsStrokeH,
  faMarsStrokeV,
  faMask,
  faMedal,
  faMedkit,
  faMeh,
  faMehBlank,
  faMehRollingEyes,
  faMemory,
  faMenorah,
  faMercury,
  faMeteor,
  faMicrochip,
  faMicrophone,
  faMicrophoneAlt,
  faMicrophoneAltSlash,
  faMicrophoneSlash,
  faMicroscope,
  faMinus,
  faMinusCircle,
  faMinusSquare,
  faMitten,
  faMobile,
  faMobileAlt,
  faMoneyBill,
  faMoneyBillAlt,
  faMoneyBillWave,
  faMoneyBillWaveAlt,
  faMoneyCheck,
  faMoneyCheckAlt,
  faMonument,
  faMoon,
  faMortarPestle,
  faMosque,
  faMotorcycle,
  faMountain,
  faMouse,
  faMousePointer,
  faMugHot,
  faMusic,
  faNetworkWired,
  faNeuter,
  faNewspaper,
  faNotEqual,
  faNotesMedical,
  faObjectGroup,
  faObjectUngroup,
  faOilCan,
  faOm,
  faOtter,
  faOutdent,
  faPager,
  faPaintBrush,
  faPaintRoller,
  faPalette,
  faPallet,
  faPaperPlane,
  faPaperclip,
  faParachuteBox,
  faParagraph,
  faParking,
  faPassport,
  faPastafarianism,
  faPaste,
  faPause,
  faPauseCircle,
  faPaw,
  faPeace,
  faPen,
  faPenAlt,
  faPenFancy,
  faPenNib,
  faPenSquare,
  faPencilAlt,
  faPencilRuler,
  faPeopleArrows,
  faPeopleCarry,
  faPepperHot,
  faPercent,
  faPercentage,
  faPersonBooth,
  faPhone,
  faPhoneAlt,
  faPhoneSlash,
  faPhoneSquare,
  faPhoneSquareAlt,
  faPhoneVolume,
  faPhotoVideo,
  faPiggyBank,
  faPills,
  faPizzaSlice,
  faPlaceOfWorship,
  faPlane,
  faPlaneArrival,
  faPlaneDeparture,
  faPlaneSlash,
  faPlay,
  faPlayCircle,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPodcast,
  faPoll,
  faPollH,
  faPoo,
  faPooStorm,
  faPoop,
  faPortrait,
  faPoundSign,
  faPowerOff,
  faPray,
  faPrayingHands,
  faPrescription,
  faPrescriptionBottle,
  faPrescriptionBottleAlt,
  faPrint,
  faProcedures,
  faProjectDiagram,
  faPumpMedical,
  faPumpSoap,
  faPuzzlePiece,
  faQrcode,
  faQuestion,
  faQuestionCircle,
  faQuidditch,
  faQuoteLeft,
  faQuoteRight,
  faQuran,
  faRadiation,
  faRadiationAlt,
  faRainbow,
  faRandom,
  faReceipt,
  faRecordVinyl,
  faRecycle,
  faRedo,
  faRedoAlt,
  faRegistered,
  faRemoveFormat,
  faReply,
  faReplyAll,
  faRepublican,
  faRestroom,
  faRetweet,
  faRibbon,
  faRing,
  faRoad,
  faRobot,
  faRocket,
  faRoute,
  faRss,
  faRssSquare,
  faRubleSign,
  faRuler,
  faRulerCombined,
  faRulerHorizontal,
  faRulerVertical,
  faRunning,
  faRupeeSign,
  faSadCry,
  faSadTear,
  faSatellite,
  faSatelliteDish,
  faSave,
  faSchool,
  faScrewdriver,
  faScroll,
  faSdCard,
  faSearch,
  faSearchDollar,
  faSearchLocation,
  faSearchMinus,
  faSearchPlus,
  faSeedling,
  faServer,
  faShapes,
  faShare,
  faShareAlt,
  faShareAltSquare,
  faShareSquare,
  faShekelSign,
  faShieldAlt,
  faShieldVirus,
  faShip,
  faShippingFast,
  faShoePrints,
  faShoppingBag,
  faShoppingBasket,
  faShoppingCart,
  faShower,
  faShuttleVan,
  faSign,
  faSignInAlt,
  faSignLanguage,
  faSignOutAlt,
  faSignal,
  faSignature,
  faSimCard,
  faSink,
  faSitemap,
  faSkating,
  faSkiing,
  faSkiingNordic,
  faSkull,
  faSkullCrossbones,
  faSlash,
  faSleigh,
  faSlidersH,
  faSmile,
  faSmileBeam,
  faSmileWink,
  faSmog,
  faSmoking,
  faSmokingBan,
  faSms,
  faSnowboarding,
  faSnowflake,
  faSnowman,
  faSnowplow,
  faSoap,
  faSocks,
  faSolarPanel,
  faSort,
  faSortAlphaDown,
  faSortAlphaDownAlt,
  faSortAlphaUp,
  faSortAlphaUpAlt,
  faSortAmountDown,
  faSortAmountDownAlt,
  faSortAmountUp,
  faSortAmountUpAlt,
  faSortDown,
  faSortNumericDown,
  faSortNumericDownAlt,
  faSortNumericUp,
  faSortNumericUpAlt,
  faSortUp,
  faSpa,
  faSpaceShuttle,
  faSpellCheck,
  faSpider,
  faSpinner,
  faSplotch,
  faSprayCan,
  faSquare,
  faSquareFull,
  faSquareRootAlt,
  faStamp,
  faStar,
  faStarAndCrescent,
  faStarHalf,
  faStarHalfAlt,
  faStarOfDavid,
  faStarOfLife,
  faStepBackward,
  faStepForward,
  faStethoscope,
  faStickyNote,
  faStop,
  faStopCircle,
  faStopwatch,
  faStopwatch20,
  faStore,
  faStoreAlt,
  faStoreAltSlash,
  faStoreSlash,
  faStream,
  faStreetView,
  faStrikethrough,
  faStroopwafel,
  faSubscript,
  faSubway,
  faSuitcase,
  faSuitcaseRolling,
  faSun,
  faSuperscript,
  faSurprise,
  faSwatchbook,
  faSwimmer,
  faSwimmingPool,
  faSynagogue,
  faSync,
  faSyncAlt,
  faSyringe,
  faTable,
  faTableTennis,
  faTablet,
  faTabletAlt,
  faTablets,
  faTachometerAlt,
  faTag,
  faTags,
  faTape,
  faTasks,
  faTaxi,
  faTeeth,
  faTeethOpen,
  faTemperatureHigh,
  faTemperatureLow,
  faTenge,
  faTerminal,
  faTextHeight,
  faTextWidth,
  faTh,
  faThLarge,
  faThList,
  faTheaterMasks,
  faThermometer,
  faThermometerEmpty,
  faThermometerFull,
  faThermometerHalf,
  faThermometerQuarter,
  faThermometerThreeQuarters,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTicketAlt,
  faTimes,
  faTimesCircle,
  faTint,
  faTintSlash,
  faTired,
  faToggleOff,
  faToggleOn,
  faToilet,
  faToiletPaper,
  faToiletPaperSlash,
  faToolbox,
  faTools,
  faTooth,
  faTorah,
  faToriiGate,
  faTractor,
  faTrademark,
  faTrafficLight,
  faTrailer,
  faTrain,
  faTram,
  faTransgender,
  faTransgenderAlt,
  faTrash,
  faTrashAlt,
  faTrashRestore,
  faTrashRestoreAlt,
  faTree,
  faTrophy,
  faTruck,
  faTruckLoading,
  faTruckMonster,
  faTruckMoving,
  faTruckPickup,
  faTshirt,
  faTty,
  faTv,
  faUmbrella,
  faUmbrellaBeach,
  faUnderline,
  faUndo,
  faUndoAlt,
  faUniversalAccess,
  faUniversity,
  faUnlink,
  faUnlock,
  faUnlockAlt,
  faUpload,
  faUser,
  faUserAlt,
  faUserAltSlash,
  faUserAstronaut,
  faUserCheck,
  faUserCircle,
  faUserClock,
  faUserCog,
  faUserEdit,
  faUserFriends,
  faUserGraduate,
  faUserInjured,
  faUserLock,
  faUserMd,
  faUserMinus,
  faUserNinja,
  faUserNurse,
  faUserPlus,
  faUserSecret,
  faUserShield,
  faUserSlash,
  faUserTag,
  faUserTie,
  faUserTimes,
  faUsers,
  faUsersCog,
  faUsersSlash,
  faUtensilSpoon,
  faUtensils,
  faVectorSquare,
  faVenus,
  faVenusDouble,
  faVenusMars,
  faVest,
  faVestPatches,
  faVial,
  faVials,
  faVideo,
  faVideoSlash,
  faVihara,
  faVirus,
  faVirusSlash,
  faViruses,
  faVoicemail,
  faVolleyballBall,
  faVolumeDown,
  faVolumeMute,
  faVolumeOff,
  faVolumeUp,
  faVoteYea,
  faVrCardboard,
  faWalking,
  faWallet,
  faWarehouse,
  faWater,
  faWaveSquare,
  faWeight,
  faWeightHanging,
  faWheelchair,
  faWifi,
  faWind,
  faWindowClose,
  faWindowMaximize,
  faWindowMinimize,
  faWindowRestore,
  faWineBottle,
  faWineGlass,
  faWineGlassAlt,
  faWonSign,
  faWrench,
  faXRay,
  faYenSign,
  faYinYang
} from '@fortawesome/free-solid-svg-icons';
import {
  faAddressBook as regularfaAddressBook,
  faAddressCard as regularfaAddressCard,
  faAngry as regularfaAngry,
  faArrowAltCircleDown as regularfaArrowAltCircleDown,
  faArrowAltCircleLeft as regularfaArrowAltCircleLeft,
  faArrowAltCircleRight as regularfaArrowAltCircleRight,
  faArrowAltCircleUp as regularfaArrowAltCircleUp,
  faBell as regularfaBell,
  faBellSlash as regularfaBellSlash,
  faBookmark as regularfaBookmark,
  faBuilding as regularfaBuilding,
  faCalendar as regularfaCalendar,
  faCalendarAlt as regularfaCalendarAlt,
  faCalendarCheck as regularfaCalendarCheck,
  faCalendarMinus as regularfaCalendarMinus,
  faCalendarPlus as regularfaCalendarPlus,
  faCalendarTimes as regularfaCalendarTimes,
  faCaretSquareDown as regularfaCaretSquareDown,
  faCaretSquareLeft as regularfaCaretSquareLeft,
  faCaretSquareRight as regularfaCaretSquareRight,
  faCaretSquareUp as regularfaCaretSquareUp,
  faChartBar as regularfaChartBar,
  faCheckCircle as regularfaCheckCircle,
  faCheckSquare as regularfaCheckSquare,
  faCircle as regularfaCircle,
  faClipboard as regularfaClipboard,
  faClock as regularfaClock,
  faClone as regularfaClone,
  faClosedCaptioning as regularfaClosedCaptioning,
  faComment as regularfaComment,
  faCommentAlt as regularfaCommentAlt,
  faCommentDots as regularfaCommentDots,
  faComments as regularfaComments,
  faCompass as regularfaCompass,
  faCopy as regularfaCopy,
  faCopyright as regularfaCopyright,
  faCreditCard as regularfaCreditCard,
  faDizzy as regularfaDizzy,
  faDotCircle as regularfaDotCircle,
  faEdit as regularfaEdit,
  faEnvelope as regularfaEnvelope,
  faEnvelopeOpen as regularfaEnvelopeOpen,
  faEye as regularfaEye,
  faEyeSlash as regularfaEyeSlash,
  faFile as regularfaFile,
  faFileAlt as regularfaFileAlt,
  faFileArchive as regularfaFileArchive,
  faFileAudio as regularfaFileAudio,
  faFileCode as regularfaFileCode,
  faFileExcel as regularfaFileExcel,
  faFileImage as regularfaFileImage,
  faFilePdf as regularfaFilePdf,
  faFilePowerpoint as regularfaFilePowerpoint,
  faFileVideo as regularfaFileVideo,
  faFileWord as regularfaFileWord,
  faFlag as regularfaFlag,
  faFlushed as regularfaFlushed,
  faFolder as regularfaFolder,
  faFolderOpen as regularfaFolderOpen,
  faFontAwesomeLogoFull as regularfaFontAwesomeLogoFull,
  faFrown as regularfaFrown,
  faFrownOpen as regularfaFrownOpen,
  faFutbol as regularfaFutbol,
  faGem as regularfaGem,
  faGrimace as regularfaGrimace,
  faGrin as regularfaGrin,
  faGrinAlt as regularfaGrinAlt,
  faGrinBeam as regularfaGrinBeam,
  faGrinBeamSweat as regularfaGrinBeamSweat,
  faGrinHearts as regularfaGrinHearts,
  faGrinSquint as regularfaGrinSquint,
  faGrinSquintTears as regularfaGrinSquintTears,
  faGrinStars as regularfaGrinStars,
  faGrinTears as regularfaGrinTears,
  faGrinTongue as regularfaGrinTongue,
  faGrinTongueSquint as regularfaGrinTongueSquint,
  faGrinTongueWink as regularfaGrinTongueWink,
  faGrinWink as regularfaGrinWink,
  faHandLizard as regularfaHandLizard,
  faHandPaper as regularfaHandPaper,
  faHandPeace as regularfaHandPeace,
  faHandPointDown as regularfaHandPointDown,
  faHandPointLeft as regularfaHandPointLeft,
  faHandPointRight as regularfaHandPointRight,
  faHandPointUp as regularfaHandPointUp,
  faHandPointer as regularfaHandPointer,
  faHandRock as regularfaHandRock,
  faHandScissors as regularfaHandScissors,
  faHandSpock as regularfaHandSpock,
  faHandshake as regularfaHandshake,
  faHdd as regularfaHdd,
  faHeart as regularfaHeart,
  faHospital as regularfaHospital,
  faHourglass as regularfaHourglass,
  faIdBadge as regularfaIdBadge,
  faIdCard as regularfaIdCard,
  faImage as regularfaImage,
  faImages as regularfaImages,
  faKeyboard as regularfaKeyboard,
  faKiss as regularfaKiss,
  faKissBeam as regularfaKissBeam,
  faKissWinkHeart as regularfaKissWinkHeart,
  faLaugh as regularfaLaugh,
  faLaughBeam as regularfaLaughBeam,
  faLaughSquint as regularfaLaughSquint,
  faLaughWink as regularfaLaughWink,
  faLemon as regularfaLemon,
  faLifeRing as regularfaLifeRing,
  faLightbulb as regularfaLightbulb,
  faListAlt as regularfaListAlt,
  faMap as regularfaMap,
  faMeh as regularfaMeh,
  faMehBlank as regularfaMehBlank,
  faMehRollingEyes as regularfaMehRollingEyes,
  faMinusSquare as regularfaMinusSquare,
  faMoneyBillAlt as regularfaMoneyBillAlt,
  faMoon as regularfaMoon,
  faNewspaper as regularfaNewspaper,
  faObjectGroup as regularfaObjectGroup,
  faObjectUngroup as regularfaObjectUngroup,
  faPaperPlane as regularfaPaperPlane,
  faPauseCircle as regularfaPauseCircle,
  faPlayCircle as regularfaPlayCircle,
  faPlusSquare as regularfaPlusSquare,
  faQuestionCircle as regularfaQuestionCircle,
  faRegistered as regularfaRegistered,
  faSadCry as regularfaSadCry,
  faSadTear as regularfaSadTear,
  faSave as regularfaSave,
  faShareSquare as regularfaShareSquare,
  faSmile as regularfaSmile,
  faSmileBeam as regularfaSmileBeam,
  faSmileWink as regularfaSmileWink,
  faSnowflake as regularfaSnowflake,
  faSquare as regularfaSquare,
  faStar as regularfaStar,
  faStarHalf as regularfaStarHalf,
  faStickyNote as regularfaStickyNote,
  faStopCircle as regularfaStopCircle,
  faSun as regularfaSun,
  faSurprise as regularfaSurprise,
  faThumbsDown as regularfaThumbsDown,
  faThumbsUp as regularfaThumbsUp,
  faTimesCircle as regularfaTimesCircle,
  faTired as regularfaTired,
  faTrashAlt as regularfaTrashAlt,
  faUser as regularfaUser,
  faUserCircle as regularfaUserCircle,
  faWindowClose as regularfaWindowClose,
  faWindowMaximize as regularfaWindowMaximize,
  faWindowMinimize as regularfaWindowMinimize,
  faWindowRestore as regularfaWindowRestore
} from '@fortawesome/free-regular-svg-icons';

const Icons = () => {
  const brands = [
    fa500px,
    faAccessibleIcon,
    faAccusoft,
    faAcquisitionsIncorporated,
    faAdn,
    faAdversal,
    faAffiliatetheme,
    faAirbnb,
    faAlgolia,
    faAlipay,
    faAmazon,
    faAmazonPay,
    faAmilia,
    faAndroid,
    faAngellist,
    faAngrycreative,
    faAngular,
    faAppStore,
    faAppStoreIos,
    faApper,
    faApple,
    faApplePay,
    faArtstation,
    faAsymmetrik,
    faAtlassian,
    faAudible,
    faAutoprefixer,
    faAvianex,
    faAviato,
    faAws,
    faBandcamp,
    faBattleNet,
    faBehance,
    faBehanceSquare,
    faBimobject,
    faBitbucket,
    faBitcoin,
    faBity,
    faBlackTie,
    faBlackberry,
    faBlogger,
    faBloggerB,
    faBluetooth,
    faBluetoothB,
    faBootstrap,
    faBtc,
    faBuffer,
    faBuromobelexperte,
    faBuyNLarge,
    faBuysellads,
    faCanadianMapleLeaf,
    faCcAmazonPay,
    faCcAmex,
    faCcApplePay,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb,
    faCcMastercard,
    faCcPaypal,
    faCcStripe,
    faCcVisa,
    faCentercode,
    faCentos,
    faChrome,
    faChromecast,
    faCloudflare,
    faCloudscale,
    faCloudsmith,
    faCloudversify,
    faCodepen,
    faCodiepie,
    faConfluence,
    faConnectdevelop,
    faContao,
    faCottonBureau,
    faCpanel,
    faCreativeCommons,
    faCreativeCommonsBy,
    faCreativeCommonsNc,
    faCreativeCommonsNcEu,
    faCreativeCommonsNcJp,
    faCreativeCommonsNd,
    faCreativeCommonsPd,
    faCreativeCommonsPdAlt,
    faCreativeCommonsRemix,
    faCreativeCommonsSa,
    faCreativeCommonsSampling,
    faCreativeCommonsSamplingPlus,
    faCreativeCommonsShare,
    faCreativeCommonsZero,
    faCriticalRole,
    faCss3,
    faCss3Alt,
    faCuttlefish,
    faDAndD,
    faDAndDBeyond,
    faDailymotion,
    faDashcube,
    faDeezer,
    faDelicious,
    faDeploydog,
    faDeskpro,
    faDev,
    faDeviantart,
    faDhl,
    faDiaspora,
    faDigg,
    faDigitalOcean,
    faDiscord,
    faDiscourse,
    faDochub,
    faDocker,
    faDraft2digital,
    faDribbble,
    faDribbbleSquare,
    faDropbox,
    faDrupal,
    faDyalog,
    faEarlybirds,
    faEbay,
    faEdge,
    faEdgeLegacy,
    faElementor,
    faEllo,
    faEmber,
    faEmpire,
    faEnvira,
    faErlang,
    faEthereum,
    faEtsy,
    faEvernote,
    faExpeditedssl,
    faFacebook,
    faFacebookF,
    faFacebookMessenger,
    faFacebookSquare,
    faFantasyFlightGames,
    faFedex,
    faFedora,
    faFigma,
    faFirefox,
    faFirefoxBrowser,
    faFirstOrder,
    faFirstOrderAlt,
    faFirstdraft,
    faFlickr,
    faFlipboard,
    faFly,
    faFontAwesome,
    faFontAwesomeAlt,
    faFontAwesomeFlag,
    faFontAwesomeLogoFull,
    faFonticons,
    faFonticonsFi,
    faFortAwesome,
    faFortAwesomeAlt,
    faForumbee,
    faFoursquare,
    faFreeCodeCamp,
    faFreebsd,
    faFulcrum,
    faGalacticRepublic,
    faGalacticSenate,
    faGetPocket,
    faGg,
    faGgCircle,
    faGit,
    faGitAlt,
    faGitSquare,
    faGithub,
    faGithubAlt,
    faGithubSquare,
    faGitkraken,
    faGitlab,
    faGitter,
    faGlide,
    faGlideG,
    faGofore,
    faGoodreads,
    faGoodreadsG,
    faGoogle,
    faGoogleDrive,
    faGooglePay,
    faGooglePlay,
    faGooglePlus,
    faGooglePlusG,
    faGooglePlusSquare,
    faGoogleWallet,
    faGratipay,
    faGrav,
    faGripfire,
    faGrunt,
    faGuilded,
    faGulp,
    faHackerNews,
    faHackerNewsSquare,
    faHackerrank,
    faHips,
    faHireAHelper,
    faHive,
    faHooli,
    faHornbill,
    faHotjar,
    faHouzz,
    faHtml5,
    faHubspot,
    faIdeal,
    faImdb,
    faInnosoft,
    faInstagram,
    faInstagramSquare,
    faInstalod,
    faIntercom,
    faInternetExplorer,
    faInvision,
    faIoxhost,
    faItchIo,
    faItunes,
    faItunesNote,
    faJava,
    faJediOrder,
    faJenkins,
    faJira,
    faJoget,
    faJoomla,
    faJs,
    faJsSquare,
    faJsfiddle,
    faKaggle,
    faKeybase,
    faKeycdn,
    faKickstarter,
    faKickstarterK,
    faKorvue,
    faLaravel,
    faLastfm,
    faLastfmSquare,
    faLeanpub,
    faLess,
    faLine,
    faLinkedin,
    faLinkedinIn,
    faLinode,
    faLinux,
    faLyft,
    faMagento,
    faMailchimp,
    faMandalorian,
    faMarkdown,
    faMastodon,
    faMaxcdn,
    faMdb,
    faMedapps,
    faMedium,
    faMediumM,
    faMedrt,
    faMeetup,
    faMegaport,
    faMendeley,
    faMicroblog,
    faMicrosoft,
    faMix,
    faMixcloud,
    faMixer,
    faMizuni,
    faModx,
    faMonero,
    faNapster,
    faNeos,
    faNimblr,
    faNode,
    faNodeJs,
    faNpm,
    faNs8,
    faNutritionix,
    faOctopusDeploy,
    faOdnoklassniki,
    faOdnoklassnikiSquare,
    faOldRepublic,
    faOpencart,
    faOpenid,
    faOpera,
    faOptinMonster,
    faOrcid,
    faOsi,
    faPage4,
    faPagelines,
    faPalfed,
    faPatreon,
    faPaypal,
    faPennyArcade,
    faPerbyte,
    faPeriscope,
    faPhabricator,
    faPhoenixFramework,
    faPhoenixSquadron,
    faPhp,
    faPiedPiper,
    faPiedPiperAlt,
    faPiedPiperHat,
    faPiedPiperPp,
    faPiedPiperSquare,
    faPinterest,
    faPinterestP,
    faPinterestSquare,
    faPlaystation,
    faProductHunt,
    faPushed,
    faPython,
    faQq,
    faQuinscape,
    faQuora,
    faRProject,
    faRaspberryPi,
    faRavelry,
    faReact,
    faReacteurope,
    faReadme,
    faRebel,
    faRedRiver,
    faReddit,
    faRedditAlien,
    faRedditSquare,
    faRedhat,
    faRenren,
    faReplyd,
    faResearchgate,
    faResolving,
    faRev,
    faRocketchat,
    faRockrms,
    faRust,
    faSafari,
    faSalesforce,
    faSass,
    faSchlix,
    faScribd,
    faSearchengin,
    faSellcast,
    faSellsy,
    faServicestack,
    faShirtsinbulk,
    faShopify,
    faShopware,
    faSimplybuilt,
    faSistrix,
    faSith,
    faSketch,
    faSkyatlas,
    faSkype,
    faSlack,
    faSlackHash,
    faSlideshare,
    faSnapchat,
    faSnapchatGhost,
    faSnapchatSquare,
    faSoundcloud,
    faSourcetree,
    faSpeakap,
    faSpeakerDeck,
    faSpotify,
    faSquarespace,
    faStackExchange,
    faStackOverflow,
    faStackpath,
    faStaylinked,
    faSteam,
    faSteamSquare,
    faSteamSymbol,
    faStickerMule,
    faStrava,
    faStripe,
    faStripeS,
    faStudiovinari,
    faStumbleupon,
    faStumbleuponCircle,
    faSuperpowers,
    faSupple,
    faSuse,
    faSwift,
    faSymfony,
    faTeamspeak,
    faTelegram,
    faTelegramPlane,
    faTencentWeibo,
    faTheRedYeti,
    faThemeco,
    faThemeisle,
    faThinkPeaks,
    faTiktok,
    faTradeFederation,
    faTrello,
    faTumblr,
    faTumblrSquare,
    faTwitch,
    faTwitter,
    faTwitterSquare,
    faTypo3,
    faUber,
    faUbuntu,
    faUikit,
    faUmbraco,
    faUncharted,
    faUniregistry,
    faUnity,
    faUnsplash,
    faUntappd,
    faUps,
    faUsb,
    faUsps,
    faUssunnah,
    faVaadin,
    faViacoin,
    faViadeo,
    faViadeoSquare,
    faViber,
    faVimeo,
    faVimeoSquare,
    faVimeoV,
    faVine,
    faVk,
    faVnv,
    faVuejs,
    faWatchmanMonitoring,
    faWaze,
    faWeebly,
    faWeibo,
    faWeixin,
    faWhatsapp,
    faWhatsappSquare,
    faWhmcs,
    faWikipediaW,
    faWindows,
    faWix,
    faWizardsOfTheCoast,
    faWodu,
    faWolfPackBattalion,
    faWordpress,
    faWordpressSimple,
    faWpbeginner,
    faWpexplorer,
    faWpforms,
    faWpressr,
    faXbox,
    faXing,
    faXingSquare,
    faYCombinator,
    faYahoo,
    faYammer,
    faYandex,
    faYandexInternational,
    faYarn,
    faYelp,
    faYoast,
    faYoutube,
    faYoutubeSquare,
    faZhihu
  ];

  const solids = [
    faAd,
    faAddressBook,
    faAddressCard,
    faAdjust,
    faAirFreshener,
    faAlignCenter,
    faAlignJustify,
    faAlignLeft,
    faAlignRight,
    faAllergies,
    faAmbulance,
    faAmericanSignLanguageInterpreting,
    faAnchor,
    faAngleDoubleDown,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDoubleUp,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faAngry,
    faAnkh,
    faAppleAlt,
    faArchive,
    faArchway,
    faArrowAltCircleDown,
    faArrowAltCircleLeft,
    faArrowAltCircleRight,
    faArrowAltCircleUp,
    faArrowCircleDown,
    faArrowCircleLeft,
    faArrowCircleRight,
    faArrowCircleUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowsAlt,
    faArrowsAltH,
    faArrowsAltV,
    faAssistiveListeningSystems,
    faAsterisk,
    faAt,
    faAtlas,
    faAtom,
    faAudioDescription,
    faAward,
    faBaby,
    faBabyCarriage,
    faBackspace,
    faBackward,
    faBacon,
    faBacteria,
    faBacterium,
    faBahai,
    faBalanceScale,
    faBalanceScaleLeft,
    faBalanceScaleRight,
    faBan,
    faBandAid,
    faBarcode,
    faBars,
    faBaseballBall,
    faBasketballBall,
    faBath,
    faBatteryEmpty,
    faBatteryFull,
    faBatteryHalf,
    faBatteryQuarter,
    faBatteryThreeQuarters,
    faBed,
    faBeer,
    faBell,
    faBellSlash,
    faBezierCurve,
    faBible,
    faBicycle,
    faBiking,
    faBinoculars,
    faBiohazard,
    faBirthdayCake,
    faBlender,
    faBlenderPhone,
    faBlind,
    faBlog,
    faBold,
    faBolt,
    faBomb,
    faBone,
    faBong,
    faBook,
    faBookDead,
    faBookMedical,
    faBookOpen,
    faBookReader,
    faBookmark,
    faBorderAll,
    faBorderNone,
    faBorderStyle,
    faBowlingBall,
    faBox,
    faBoxOpen,
    faBoxTissue,
    faBoxes,
    faBraille,
    faBrain,
    faBreadSlice,
    faBriefcase,
    faBriefcaseMedical,
    faBroadcastTower,
    faBroom,
    faBrush,
    faBug,
    faBuilding,
    faBullhorn,
    faBullseye,
    faBurn,
    faBus,
    faBusAlt,
    faBusinessTime,
    faCalculator,
    faCalendar,
    faCalendarAlt,
    faCalendarCheck,
    faCalendarDay,
    faCalendarMinus,
    faCalendarPlus,
    faCalendarTimes,
    faCalendarWeek,
    faCamera,
    faCameraRetro,
    faCampground,
    faCandyCane,
    faCannabis,
    faCapsules,
    faCar,
    faCarAlt,
    faCarBattery,
    faCarCrash,
    faCarSide,
    faCaravan,
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faCaretSquareDown,
    faCaretSquareLeft,
    faCaretSquareRight,
    faCaretSquareUp,
    faCaretUp,
    faCarrot,
    faCartArrowDown,
    faCartPlus,
    faCashRegister,
    faCat,
    faCertificate,
    faChair,
    faChalkboard,
    faChalkboardTeacher,
    faChargingStation,
    faChartArea,
    faChartBar,
    faChartLine,
    faChartPie,
    faCheck,
    faCheckCircle,
    faCheckDouble,
    faCheckSquare,
    faCheese,
    faChess,
    faChessBishop,
    faChessBoard,
    faChessKing,
    faChessKnight,
    faChessPawn,
    faChessQueen,
    faChessRook,
    faChevronCircleDown,
    faChevronCircleLeft,
    faChevronCircleRight,
    faChevronCircleUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChild,
    faChurch,
    faCircle,
    faCircleNotch,
    faCity,
    faClinicMedical,
    faClipboard,
    faClipboardCheck,
    faClipboardList,
    faClock,
    faClone,
    faClosedCaptioning,
    faCloud,
    faCloudDownloadAlt,
    faCloudMeatball,
    faCloudMoon,
    faCloudMoonRain,
    faCloudRain,
    faCloudShowersHeavy,
    faCloudSun,
    faCloudSunRain,
    faCloudUploadAlt,
    faCocktail,
    faCode,
    faCodeBranch,
    faCoffee,
    faCog,
    faCogs,
    faCoins,
    faColumns,
    faComment,
    faCommentAlt,
    faCommentDollar,
    faCommentDots,
    faCommentMedical,
    faCommentSlash,
    faComments,
    faCommentsDollar,
    faCompactDisc,
    faCompass,
    faCompress,
    faCompressAlt,
    faCompressArrowsAlt,
    faConciergeBell,
    faCookie,
    faCookieBite,
    faCopy,
    faCopyright,
    faCouch,
    faCreditCard,
    faCrop,
    faCropAlt,
    faCross,
    faCrosshairs,
    faCrow,
    faCrown,
    faCrutch,
    faCube,
    faCubes,
    faCut,
    faDatabase,
    faDeaf,
    faDemocrat,
    faDesktop,
    faDharmachakra,
    faDiagnoses,
    faDice,
    faDiceD20,
    faDiceD6,
    faDiceFive,
    faDiceFour,
    faDiceOne,
    faDiceSix,
    faDiceThree,
    faDiceTwo,
    faDigitalTachograph,
    faDirections,
    faDisease,
    faDivide,
    faDizzy,
    faDna,
    faDog,
    faDollarSign,
    faDolly,
    faDollyFlatbed,
    faDonate,
    faDoorClosed,
    faDoorOpen,
    faDotCircle,
    faDove,
    faDownload,
    faDraftingCompass,
    faDragon,
    faDrawPolygon,
    faDrum,
    faDrumSteelpan,
    faDrumstickBite,
    faDumbbell,
    faDumpster,
    faDumpsterFire,
    faDungeon,
    faEdit,
    faEgg,
    faEject,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faEnvelopeOpen,
    faEnvelopeOpenText,
    faEnvelopeSquare,
    faEquals,
    faEraser,
    faEthernet,
    faEuroSign,
    faExchangeAlt,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExpandAlt,
    faExpandArrowsAlt,
    faExternalLinkAlt,
    faExternalLinkSquareAlt,
    faEye,
    faEyeDropper,
    faEyeSlash,
    faFan,
    faFastBackward,
    faFastForward,
    faFaucet,
    faFax,
    faFeather,
    faFeatherAlt,
    faFemale,
    faFighterJet,
    faFile,
    faFileAlt,
    faFileArchive,
    faFileAudio,
    faFileCode,
    faFileContract,
    faFileCsv,
    faFileDownload,
    faFileExcel,
    faFileExport,
    faFileImage,
    faFileImport,
    faFileInvoice,
    faFileInvoiceDollar,
    faFileMedical,
    faFileMedicalAlt,
    faFilePdf,
    faFilePowerpoint,
    faFilePrescription,
    faFileSignature,
    faFileUpload,
    faFileVideo,
    faFileWord,
    faFill,
    faFillDrip,
    faFilm,
    faFilter,
    faFingerprint,
    faFire,
    faFireAlt,
    faFireExtinguisher,
    faFirstAid,
    faFish,
    faFistRaised,
    faFlag,
    faFlagCheckered,
    faFlagUsa,
    faFlask,
    faFlushed,
    faFolder,
    faFolderMinus,
    faFolderOpen,
    faFolderPlus,
    faFont,
    zmfaFontAwesomeLogoFull,
    faFootballBall,
    faForward,
    faFrog,
    faFrown,
    faFrownOpen,
    faFunnelDollar,
    faFutbol,
    faGamepad,
    faGasPump,
    faGavel,
    faGem,
    faGenderless,
    faGhost,
    faGift,
    faGifts,
    faGlassCheers,
    faGlassMartini,
    faGlassMartiniAlt,
    faGlassWhiskey,
    faGlasses,
    faGlobe,
    faGlobeAfrica,
    faGlobeAmericas,
    faGlobeAsia,
    faGlobeEurope,
    faGolfBall,
    faGopuram,
    faGraduationCap,
    faGreaterThan,
    faGreaterThanEqual,
    faGrimace,
    faGrin,
    faGrinAlt,
    faGrinBeam,
    faGrinBeamSweat,
    faGrinHearts,
    faGrinSquint,
    faGrinSquintTears,
    faGrinStars,
    faGrinTears,
    faGrinTongue,
    faGrinTongueSquint,
    faGrinTongueWink,
    faGrinWink,
    faGripHorizontal,
    faGripLines,
    faGripLinesVertical,
    faGripVertical,
    faGuitar,
    faHSquare,
    faHamburger,
    faHammer,
    faHamsa,
    faHandHolding,
    faHandHoldingHeart,
    faHandHoldingMedical,
    faHandHoldingUsd,
    faHandHoldingWater,
    faHandLizard,
    faHandMiddleFinger,
    faHandPaper,
    faHandPeace,
    faHandPointDown,
    faHandPointLeft,
    faHandPointRight,
    faHandPointUp,
    faHandPointer,
    faHandRock,
    faHandScissors,
    faHandSparkles,
    faHandSpock,
    faHands,
    faHandsHelping,
    faHandsWash,
    faHandshake,
    faHandshakeAltSlash,
    faHandshakeSlash,
    faHanukiah,
    faHardHat,
    faHashtag,
    faHatCowboy,
    faHatCowboySide,
    faHatWizard,
    faHdd,
    faHeadSideCough,
    faHeadSideCoughSlash,
    faHeadSideMask,
    faHeadSideVirus,
    faHeading,
    faHeadphones,
    faHeadphonesAlt,
    faHeadset,
    faHeart,
    faHeartBroken,
    faHeartbeat,
    faHelicopter,
    faHighlighter,
    faHiking,
    faHippo,
    faHistory,
    faHockeyPuck,
    faHollyBerry,
    faHome,
    faHorse,
    faHorseHead,
    faHospital,
    faHospitalAlt,
    faHospitalSymbol,
    faHospitalUser,
    faHotTub,
    faHotdog,
    faHotel,
    faHourglass,
    faHourglassEnd,
    faHourglassHalf,
    faHourglassStart,
    faHouseDamage,
    faHouseUser,
    faHryvnia,
    faICursor,
    faIceCream,
    faIcicles,
    faIcons,
    faIdBadge,
    faIdCard,
    faIdCardAlt,
    faIgloo,
    faImage,
    faImages,
    faInbox,
    faIndent,
    faIndustry,
    faInfinity,
    faInfo,
    faInfoCircle,
    faItalic,
    faJedi,
    faJoint,
    faJournalWhills,
    faKaaba,
    faKey,
    faKeyboard,
    faKhanda,
    faKiss,
    faKissBeam,
    faKissWinkHeart,
    faKiwiBird,
    faLandmark,
    faLanguage,
    faLaptop,
    faLaptopCode,
    faLaptopHouse,
    faLaptopMedical,
    faLaugh,
    faLaughBeam,
    faLaughSquint,
    faLaughWink,
    faLayerGroup,
    faLeaf,
    faLemon,
    faLessThan,
    faLessThanEqual,
    faLevelDownAlt,
    faLevelUpAlt,
    faLifeRing,
    faLightbulb,
    faLink,
    faLiraSign,
    faList,
    faListAlt,
    faListOl,
    faListUl,
    faLocationArrow,
    faLock,
    faLockOpen,
    faLongArrowAltDown,
    faLongArrowAltLeft,
    faLongArrowAltRight,
    faLongArrowAltUp,
    faLowVision,
    faLuggageCart,
    faLungs,
    faLungsVirus,
    faMagic,
    faMagnet,
    faMailBulk,
    faMale,
    faMap,
    faMapMarked,
    faMapMarkedAlt,
    faMapMarker,
    faMapMarkerAlt,
    faMapPin,
    faMapSigns,
    faMarker,
    faMars,
    faMarsDouble,
    faMarsStroke,
    faMarsStrokeH,
    faMarsStrokeV,
    faMask,
    faMedal,
    faMedkit,
    faMeh,
    faMehBlank,
    faMehRollingEyes,
    faMemory,
    faMenorah,
    faMercury,
    faMeteor,
    faMicrochip,
    faMicrophone,
    faMicrophoneAlt,
    faMicrophoneAltSlash,
    faMicrophoneSlash,
    faMicroscope,
    faMinus,
    faMinusCircle,
    faMinusSquare,
    faMitten,
    faMobile,
    faMobileAlt,
    faMoneyBill,
    faMoneyBillAlt,
    faMoneyBillWave,
    faMoneyBillWaveAlt,
    faMoneyCheck,
    faMoneyCheckAlt,
    faMonument,
    faMoon,
    faMortarPestle,
    faMosque,
    faMotorcycle,
    faMountain,
    faMouse,
    faMousePointer,
    faMugHot,
    faMusic,
    faNetworkWired,
    faNeuter,
    faNewspaper,
    faNotEqual,
    faNotesMedical,
    faObjectGroup,
    faObjectUngroup,
    faOilCan,
    faOm,
    faOtter,
    faOutdent,
    faPager,
    faPaintBrush,
    faPaintRoller,
    faPalette,
    faPallet,
    faPaperPlane,
    faPaperclip,
    faParachuteBox,
    faParagraph,
    faParking,
    faPassport,
    faPastafarianism,
    faPaste,
    faPause,
    faPauseCircle,
    faPaw,
    faPeace,
    faPen,
    faPenAlt,
    faPenFancy,
    faPenNib,
    faPenSquare,
    faPencilAlt,
    faPencilRuler,
    faPeopleArrows,
    faPeopleCarry,
    faPepperHot,
    faPercent,
    faPercentage,
    faPersonBooth,
    faPhone,
    faPhoneAlt,
    faPhoneSlash,
    faPhoneSquare,
    faPhoneSquareAlt,
    faPhoneVolume,
    faPhotoVideo,
    faPiggyBank,
    faPills,
    faPizzaSlice,
    faPlaceOfWorship,
    faPlane,
    faPlaneArrival,
    faPlaneDeparture,
    faPlaneSlash,
    faPlay,
    faPlayCircle,
    faPlug,
    faPlus,
    faPlusCircle,
    faPlusSquare,
    faPodcast,
    faPoll,
    faPollH,
    faPoo,
    faPooStorm,
    faPoop,
    faPortrait,
    faPoundSign,
    faPowerOff,
    faPray,
    faPrayingHands,
    faPrescription,
    faPrescriptionBottle,
    faPrescriptionBottleAlt,
    faPrint,
    faProcedures,
    faProjectDiagram,
    faPumpMedical,
    faPumpSoap,
    faPuzzlePiece,
    faQrcode,
    faQuestion,
    faQuestionCircle,
    faQuidditch,
    faQuoteLeft,
    faQuoteRight,
    faQuran,
    faRadiation,
    faRadiationAlt,
    faRainbow,
    faRandom,
    faReceipt,
    faRecordVinyl,
    faRecycle,
    faRedo,
    faRedoAlt,
    faRegistered,
    faRemoveFormat,
    faReply,
    faReplyAll,
    faRepublican,
    faRestroom,
    faRetweet,
    faRibbon,
    faRing,
    faRoad,
    faRobot,
    faRocket,
    faRoute,
    faRss,
    faRssSquare,
    faRubleSign,
    faRuler,
    faRulerCombined,
    faRulerHorizontal,
    faRulerVertical,
    faRunning,
    faRupeeSign,
    faSadCry,
    faSadTear,
    faSatellite,
    faSatelliteDish,
    faSave,
    faSchool,
    faScrewdriver,
    faScroll,
    faSdCard,
    faSearch,
    faSearchDollar,
    faSearchLocation,
    faSearchMinus,
    faSearchPlus,
    faSeedling,
    faServer,
    faShapes,
    faShare,
    faShareAlt,
    faShareAltSquare,
    faShareSquare,
    faShekelSign,
    faShieldAlt,
    faShieldVirus,
    faShip,
    faShippingFast,
    faShoePrints,
    faShoppingBag,
    faShoppingBasket,
    faShoppingCart,
    faShower,
    faShuttleVan,
    faSign,
    faSignInAlt,
    faSignLanguage,
    faSignOutAlt,
    faSignal,
    faSignature,
    faSimCard,
    faSink,
    faSitemap,
    faSkating,
    faSkiing,
    faSkiingNordic,
    faSkull,
    faSkullCrossbones,
    faSlash,
    faSleigh,
    faSlidersH,
    faSmile,
    faSmileBeam,
    faSmileWink,
    faSmog,
    faSmoking,
    faSmokingBan,
    faSms,
    faSnowboarding,
    faSnowflake,
    faSnowman,
    faSnowplow,
    faSoap,
    faSocks,
    faSolarPanel,
    faSort,
    faSortAlphaDown,
    faSortAlphaDownAlt,
    faSortAlphaUp,
    faSortAlphaUpAlt,
    faSortAmountDown,
    faSortAmountDownAlt,
    faSortAmountUp,
    faSortAmountUpAlt,
    faSortDown,
    faSortNumericDown,
    faSortNumericDownAlt,
    faSortNumericUp,
    faSortNumericUpAlt,
    faSortUp,
    faSpa,
    faSpaceShuttle,
    faSpellCheck,
    faSpider,
    faSpinner,
    faSplotch,
    faSprayCan,
    faSquare,
    faSquareFull,
    faSquareRootAlt,
    faStamp,
    faStar,
    faStarAndCrescent,
    faStarHalf,
    faStarHalfAlt,
    faStarOfDavid,
    faStarOfLife,
    faStepBackward,
    faStepForward,
    faStethoscope,
    faStickyNote,
    faStop,
    faStopCircle,
    faStopwatch,
    faStopwatch20,
    faStore,
    faStoreAlt,
    faStoreAltSlash,
    faStoreSlash,
    faStream,
    faStreetView,
    faStrikethrough,
    faStroopwafel,
    faSubscript,
    faSubway,
    faSuitcase,
    faSuitcaseRolling,
    faSun,
    faSuperscript,
    faSurprise,
    faSwatchbook,
    faSwimmer,
    faSwimmingPool,
    faSynagogue,
    faSync,
    faSyncAlt,
    faSyringe,
    faTable,
    faTableTennis,
    faTablet,
    faTabletAlt,
    faTablets,
    faTachometerAlt,
    faTag,
    faTags,
    faTape,
    faTasks,
    faTaxi,
    faTeeth,
    faTeethOpen,
    faTemperatureHigh,
    faTemperatureLow,
    faTenge,
    faTerminal,
    faTextHeight,
    faTextWidth,
    faTh,
    faThLarge,
    faThList,
    faTheaterMasks,
    faThermometer,
    faThermometerEmpty,
    faThermometerFull,
    faThermometerHalf,
    faThermometerQuarter,
    faThermometerThreeQuarters,
    faThumbsDown,
    faThumbsUp,
    faThumbtack,
    faTicketAlt,
    faTimes,
    faTimesCircle,
    faTint,
    faTintSlash,
    faTired,
    faToggleOff,
    faToggleOn,
    faToilet,
    faToiletPaper,
    faToiletPaperSlash,
    faToolbox,
    faTools,
    faTooth,
    faTorah,
    faToriiGate,
    faTractor,
    faTrademark,
    faTrafficLight,
    faTrailer,
    faTrain,
    faTram,
    faTransgender,
    faTransgenderAlt,
    faTrash,
    faTrashAlt,
    faTrashRestore,
    faTrashRestoreAlt,
    faTree,
    faTrophy,
    faTruck,
    faTruckLoading,
    faTruckMonster,
    faTruckMoving,
    faTruckPickup,
    faTshirt,
    faTty,
    faTv,
    faUmbrella,
    faUmbrellaBeach,
    faUnderline,
    faUndo,
    faUndoAlt,
    faUniversalAccess,
    faUniversity,
    faUnlink,
    faUnlock,
    faUnlockAlt,
    faUpload,
    faUser,
    faUserAlt,
    faUserAltSlash,
    faUserAstronaut,
    faUserCheck,
    faUserCircle,
    faUserClock,
    faUserCog,
    faUserEdit,
    faUserFriends,
    faUserGraduate,
    faUserInjured,
    faUserLock,
    faUserMd,
    faUserMinus,
    faUserNinja,
    faUserNurse,
    faUserPlus,
    faUserSecret,
    faUserShield,
    faUserSlash,
    faUserTag,
    faUserTie,
    faUserTimes,
    faUsers,
    faUsersCog,
    faUsersSlash,
    faUtensilSpoon,
    faUtensils,
    faVectorSquare,
    faVenus,
    faVenusDouble,
    faVenusMars,
    faVest,
    faVestPatches,
    faVial,
    faVials,
    faVideo,
    faVideoSlash,
    faVihara,
    faVirus,
    faVirusSlash,
    faViruses,
    faVoicemail,
    faVolleyballBall,
    faVolumeDown,
    faVolumeMute,
    faVolumeOff,
    faVolumeUp,
    faVoteYea,
    faVrCardboard,
    faWalking,
    faWallet,
    faWarehouse,
    faWater,
    faWaveSquare,
    faWeight,
    faWeightHanging,
    faWheelchair,
    faWifi,
    faWind,
    faWindowClose,
    faWindowMaximize,
    faWindowMinimize,
    faWindowRestore,
    faWineBottle,
    faWineGlass,
    faWineGlassAlt,
    faWonSign,
    faWrench,
    faXRay,
    faYenSign,
    faYinYang
  ];

  const regulars = [
    regularfaAddressBook,
    regularfaAddressCard,
    regularfaAngry,
    regularfaArrowAltCircleDown,
    regularfaArrowAltCircleLeft,
    regularfaArrowAltCircleRight,
    regularfaArrowAltCircleUp,
    regularfaBell,
    regularfaBellSlash,
    regularfaBookmark,
    regularfaBuilding,
    regularfaCalendar,
    regularfaCalendarAlt,
    regularfaCalendarCheck,
    regularfaCalendarMinus,
    regularfaCalendarPlus,
    regularfaCalendarTimes,
    regularfaCaretSquareDown,
    regularfaCaretSquareLeft,
    regularfaCaretSquareRight,
    regularfaCaretSquareUp,
    regularfaChartBar,
    regularfaCheckCircle,
    regularfaCheckSquare,
    regularfaCircle,
    regularfaClipboard,
    regularfaClock,
    regularfaClone,
    regularfaClosedCaptioning,
    regularfaComment,
    regularfaCommentAlt,
    regularfaCommentDots,
    regularfaComments,
    regularfaCompass,
    regularfaCopy,
    regularfaCopyright,
    regularfaCreditCard,
    regularfaDizzy,
    regularfaDotCircle,
    regularfaEdit,
    regularfaEnvelope,
    regularfaEnvelopeOpen,
    regularfaEye,
    regularfaEyeSlash,
    regularfaFile,
    regularfaFileAlt,
    regularfaFileArchive,
    regularfaFileAudio,
    regularfaFileCode,
    regularfaFileExcel,
    regularfaFileImage,
    regularfaFilePdf,
    regularfaFilePowerpoint,
    regularfaFileVideo,
    regularfaFileWord,
    regularfaFlag,
    regularfaFlushed,
    regularfaFolder,
    regularfaFolderOpen,
    regularfaFontAwesomeLogoFull,
    regularfaFrown,
    regularfaFrownOpen,
    regularfaFutbol,
    regularfaGem,
    regularfaGrimace,
    regularfaGrin,
    regularfaGrinAlt,
    regularfaGrinBeam,
    regularfaGrinBeamSweat,
    regularfaGrinHearts,
    regularfaGrinSquint,
    regularfaGrinSquintTears,
    regularfaGrinStars,
    regularfaGrinTears,
    regularfaGrinTongue,
    regularfaGrinTongueSquint,
    regularfaGrinTongueWink,
    regularfaGrinWink,
    regularfaHandLizard,
    regularfaHandPaper,
    regularfaHandPeace,
    regularfaHandPointDown,
    regularfaHandPointLeft,
    regularfaHandPointRight,
    regularfaHandPointUp,
    regularfaHandPointer,
    regularfaHandRock,
    regularfaHandScissors,
    regularfaHandSpock,
    regularfaHandshake,
    regularfaHdd,
    regularfaHeart,
    regularfaHospital,
    regularfaHourglass,
    regularfaIdBadge,
    regularfaIdCard,
    regularfaImage,
    regularfaImages,
    regularfaKeyboard,
    regularfaKiss,
    regularfaKissBeam,
    regularfaKissWinkHeart,
    regularfaLaugh,
    regularfaLaughBeam,
    regularfaLaughSquint,
    regularfaLaughWink,
    regularfaLemon,
    regularfaLifeRing,
    regularfaLightbulb,
    regularfaListAlt,
    regularfaMap,
    regularfaMeh,
    regularfaMehBlank,
    regularfaMehRollingEyes,
    regularfaMinusSquare,
    regularfaMoneyBillAlt,
    regularfaMoon,
    regularfaNewspaper,
    regularfaObjectGroup,
    regularfaObjectUngroup,
    regularfaPaperPlane,
    regularfaPauseCircle,
    regularfaPlayCircle,
    regularfaPlusSquare,
    regularfaQuestionCircle,
    regularfaRegistered,
    regularfaSadCry,
    regularfaSadTear,
    regularfaSave,
    regularfaShareSquare,
    regularfaSmile,
    regularfaSmileBeam,
    regularfaSmileWink,
    regularfaSnowflake,
    regularfaSquare,
    regularfaStar,
    regularfaStarHalf,
    regularfaStickyNote,
    regularfaStopCircle,
    regularfaSun,
    regularfaSurprise,
    regularfaThumbsDown,
    regularfaThumbsUp,
    regularfaTimesCircle,
    regularfaTired,
    regularfaTrashAlt,
    regularfaUser,
    regularfaUserCircle,
    regularfaWindowClose,
    regularfaWindowMaximize,
    regularfaWindowMinimize,
    regularfaWindowRestore
  ];

  const icons = [];
  //Add icons in library
  for (const p in library.definitions) {
    const ics = library.definitions[p];
    for (const sp in ics) {
      icons.push([p, sp]);
    }
  }

  return (
    <>
      <h1 className="m-3">brands</h1>
      <hr></hr>
      {brands.map((ic, index) => {
        return (
          <FontAwesomeIcon
            className="m-3"
            key={index}
            icon={ic}
            title={`${ic.prefix},${ic.iconName}`}
          />
        );
      })}
      <h1 className="m-3">solids</h1>
      <hr></hr>
      {solids.map((ic, index) => {
        return (
          <FontAwesomeIcon
            className="m-3"
            key={index}
            icon={ic}
            title={`${ic.prefix},${ic.iconName}`}
          />
        );
      })}
      <h1 className="m-3">regulars</h1>
      <hr></hr>
      {regulars.map((ic, index) => {
        return (
          <FontAwesomeIcon
            className="m-3"
            key={index}
            icon={ic}
            title={`${ic.prefix},${ic.iconName}`}
          />
        );
      })}

      <h1 className="m-3">library</h1>
      <hr></hr>
      {icons.map((ic, index) => {
        return (
          <FontAwesomeIcon
            className="m-3"
            key={index}
            icon={ic}
            title={`${ic[0]},${ic[1]}`}
          />
        );
      })}
    </>
  );
};

export default Icons;
